<template>
	<doughnut 
	:height="height"
	:chart-data="data" 
	:chart-options="options" />
</template>

<script> 

	import { Doughnut } from 'vue-chartjs/legacy'

	import { 
		Chart as ChartJS, 
		Title, 
		Tooltip, 
		Legend, 
		BarElement, 
		CategoryScale, 
		LinearScale 
	} from 'chart.js'

	ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

	export default { 

		props: {

			height: {
				type: Number,
				default: 250
			},

			chartData: {
				type: Object,
				default: () => {}
			}, 

			options: {
				type: Object,
				default: () => {}
			}

		},

		components: {
			Doughnut,
		},

		computed: {
			data() {
				return this.chartData ? this.chartData : {}
			}
		}

	}

</script> 